import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export const getFile = (url) => {
	return new Promise((resolve, reject) => {
		fetch(url, {
			method: 'GET',
			cache: 'force-cache',
			credentials: 'same-origin',
			origin: true,
		})
			.then((response) => resolve(response.json()))
			.catch((error) => reject(error));
	});
};

export default function FileSelector({ JSONData, onChange = () => {}, label }) {
	const [options, setOptions] = useState([]);
	const [selectedValue, setSelectedValue] = useState('');

	const parseJson = () => {
		try {
			if (JSONData?.outputs) {
				// we need to extract each output for the select
				const optionsList = JSONData?.outputs.map((e) => ({
					name: e.title == '' ? e.name : e.title,
					value: `${JSONData?.path}/${JSONData?.id}/${e.file}`,
				}));
				setOptions(optionsList);
				if (optionsList.length > 0) {
					handleChange(optionsList[0].value);
				}
			} else {
				// it's not a list. We should assume it's the raw output (display:true)
				onChange(JSONData);
			}
		} catch (error) {}
	};

	const handleChange = (value) => {
		console.log(value);
		setSelectedValue(value);
		getFile(value)
			.then((_json_resp) => {
				onChange(_json_resp);
			})
			.catch((error) => {
				console.log(error);
			});
		// get the file, then trigger on change
		// onChange(JSONData);
	};

	useEffect(() => {
		parseJson();
	}, [JSONData]);

	if (parseInt(options?.length) < 2) {
		return null;
	}

	return (
		<Box sx={{ minWidth: 120 }} py={2}>
			<FormControl fullWidth>
				<InputLabel id="vistable-select-label">{label}</InputLabel>
				<Select
					labelId="vistable-select-label"
					id="vistable-select"
					value={selectedValue}
					label={label}
					onChange={(event) => {
						handleChange(event.target.value);
					}}
				>
					{options.map((e, i) => (
						<MenuItem key={`tsel_${i}`} value={e.value}>
							{e.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	);
}
